<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00086 15.4283C6.32685 13.5852 4.05662 12.3915 1.58943 12.0569C1.30861 12.0258 1.04925 11.8917 0.861412 11.6808C0.673575 11.4697 0.570574 11.1965 0.572287 10.914V1.71401C0.572276 1.54893 0.608026 1.38581 0.677077 1.23587C0.746128 1.08594 0.846841 0.952736 0.972287 0.845437C1.09552 0.740089 1.23976 0.662168 1.39543 0.616848C1.55109 0.571528 1.71462 0.559847 1.87515 0.582579C4.23433 0.97413 6.39254 2.14987 8.00086 3.91972V15.4283Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 15.4283C9.67401 13.5852 11.9442 12.3915 14.4114 12.0569C14.6922 12.0258 14.9517 11.8917 15.1394 11.6808C15.3273 11.4697 15.4303 11.1965 15.4286 10.914V1.71401C15.4286 1.54893 15.3928 1.38581 15.3238 1.23587C15.2547 1.08594 15.1541 0.952736 15.0286 0.845437C14.9054 0.740089 14.7611 0.662168 14.6055 0.616848C14.4497 0.571528 14.2863 0.559847 14.1257 0.582579C11.7665 0.97413 9.60832 2.14987 8 3.91972V15.4283Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
